export default {
    state_default_properties: {
      default_lang_code:'en-US',
      default_branch_name: 'Trunk',
      default_asof: "Now",
      default_preview_style: 'html',
      idletimeout_duration: 60,  //timeout in minutes
      browse_asof_filter: "Now",
      asof_dialog_option: 'asofnow',
      task_filter_claimed:'all',
      global_project_categories:[],
      task_selected_tab:'0',
      editor_side_active_tab: 'hide', //'tasks','ditabases','hide'
      auto_save_interval:  600, //seconds  
      filepackage_display_primary:true,
      editor_filepackage_display_primary:true,
      task_file_template_list:[],
      editors: [],
      navigators: [],
      preview_profiles:[],
      task_task_list: [],
      global_labels:[],
      preview_mru:[],
      preview_rootmaps:[],
      task_finish_form:[],
      dirty_files:[],
      unlock_on_close: true,
      open_ditabases: [],
      editor_mru: [],
      task_selected_task: null,
      filepackage_file_list: [],
      active_editor_idx: null,
      asof_dialog_message: null,
      asof_dialog_open: null,
      asof_dialog_selected_label: null,
      browse_branch_filter: null,
      browse_files: null,
      browse_lang_filter: null,
      browse_mimetype_filter: null,
      browse_refresh_files: null,
      browse_selected_file: null,
      browse_selected_folder: null,
      create_file_dialog_open: null,
      createfile_dialog_message: null,
      editor_filepackage_file_list: null,
      editor_selected_file: null,
      file_properties_dialog_file: null,
      folder_create_file_dialog_open: null,
      folder_createfile_dialog_message: null,
      folder_createfile_name_exists_in_collection: null,
      folder_createfile_template: null,
      folder_import_dialog_open: null,
      folder_import_files_list: null,
      global_projects: null,
      import_dialog_open: null,
      profile_dialog_open: null,
      profileSelectedProfile: null,
      project_dialog_open: null,
      rootmap_dialog_open: null,
      rootmapSelectedProjectCat: null,
      rootmapSelectedRootmap: null,
      search_asof_filter: null,
      search_branch_filter: null,
      search_filters_dialog_open: null,
      search_folder_filter: null,
      search_lang_filter: null,
      search_searchterm_filter: null,
      search_selected_file: null,
      search_subfolders_filter: null,
      select_file_dialog_branch_filter: null,
      select_file_dialog_files: null,
      select_file_dialog_folderitem: null,
      select_file_dialog_lang_filter: null,
      select_file_dialog_open: null,
      select_file_dialog_project: null,
      select_file_dialog_search_subfolders: null,
      select_file_dialog_search_term: null,
      select_file_highlight_folder: null,
      select_file_selected_file: null,
      select_folder_dialog_folder_selected: null,
      select_folder_dialog_open: null,
      select_folder_dialog_project: null,
      selected_collectionId: null,
      selected_taskInstId: null,
      selectedProjectCat: null,
      task_createfile_name: null,
      task_createfile_name_exists_in_collection: null,
      task_createfile_template: null,
      task_filter_project: null,
      task_finish_form_dialog_open: null,
      task_history_item_detail_dialog_open: null,
      task_properties_dialog: null,
      task_selected_history_item: null,
      active_navigator_idx:null

    }
};
